import { render } from "./ErrorSplash.vue?vue&type=template&id=7bf8085e&scoped=true&ts=true"
import script from "./ErrorSplash.vue?vue&type=script&lang=ts"
export * from "./ErrorSplash.vue?vue&type=script&lang=ts"

import "./ErrorSplash.vue?vue&type=style&index=0&id=7bf8085e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf8085e"]])

export default __exports__